"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AUTH_ACTION;
(function (AUTH_ACTION) {
    AUTH_ACTION[AUTH_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    AUTH_ACTION[AUTH_ACTION["ERROR"] = 1] = "ERROR";
    AUTH_ACTION[AUTH_ACTION["REQUEST"] = 2] = "REQUEST";
    AUTH_ACTION[AUTH_ACTION["AUTH_SUCCESSFUL"] = 3] = "AUTH_SUCCESSFUL";
    AUTH_ACTION[AUTH_ACTION["AUTH_UNSUCCESSFUL"] = 4] = "AUTH_UNSUCCESSFUL";
    AUTH_ACTION[AUTH_ACTION["TOO_MANY_AUTH_ATTEMPTS"] = 100] = "TOO_MANY_AUTH_ATTEMPTS";
    AUTH_ACTION[AUTH_ACTION["INVALID_MESSAGE"] = 101] = "INVALID_MESSAGE";
    AUTH_ACTION[AUTH_ACTION["INVALID_MESSAGE_DATA"] = 102] = "INVALID_MESSAGE_DATA";
})(AUTH_ACTION = exports.AUTH_ACTION || (exports.AUTH_ACTION = {}));
//# sourceMappingURL=auth.js.map